@use "@styles/_variables/colors" as *;
@use "@styles/_variables/breakpoints" as *;
@use "@styles/_variables/sizes" as *;

.specialties {
  margin-bottom: $tab-quadruple;

  @media all and (max-width: $mobile-large) {
    margin-bottom: $tab-quadruple-mobile-large;
  }

  @media all and (max-width: $mobile-small) {
    margin-bottom: $tab-quadruple-mobile-small;
  }
}
